import { $gettext } from '@/services/translations'

/**
 * Available Exports
 */

const ANONYMOUS_DONATIONS = 'ANONYMOUS_DONATIONS'
const DISBURSEMENTS = 'DISBURSEMENTS'
const EMPLOYEE_CODE_IMPORTS = 'EMPLOYEE_CODE_IMPORTS'
const EVENTS = 'EVENTS'
const EXPENSES = 'EXPENSES'
const MESSAGES = 'MESSAGES'
const EXTERNAL_DONATIONS = 'OFF_GRANT_CIRCLE_DONATIONS'
const PAYROLL_REQUESTS = 'PAYROLL_REQUESTS'
const REQUESTS = 'REQUESTS'
const SURVEY_ANSWERS = 'SURVEY_ANSWERS'
const SURVEY_RESPONSES = 'SURVEY_RESPONSES'
const USERS = 'USERS'
const USER_DONATIONS = 'USER_DONATIONS'
const USER_EVENTS = 'USER_EVENTS'
const RECURRING_DONATIONS = 'RECURRING_DONATIONS'
const ADMIN_AUDIT_TRAIL = 'ADMIN_AUDIT_TRAIL'
const ORGANIZATION_DEFAULT = 'ORGANIZATION_DEFAULT'

const EXPORTABLE_DATASETS = [
  { value: ADMIN_AUDIT_TRAIL, label: $gettext('Admin Audit Trail') },
  { value: ANONYMOUS_DONATIONS, label: $gettext('Anonymous Donations') },
  { value: DISBURSEMENTS, label: $gettext('Disbursements') },
  { value: EMPLOYEE_CODE_IMPORTS, label: $gettext('Employee Code Imports') },
  { value: EVENTS, label: $gettext('Events') },
  { value: EXPENSES, label: $gettext('Expenses') },
  { value: MESSAGES, label: $gettext('Messages') },
  { value: EXTERNAL_DONATIONS, label: $gettext('Off-Grant Circle Donations') },
  { value: PAYROLL_REQUESTS, label: $gettext('Payroll Requests') },
  { value: REQUESTS, label: $gettext('Requests') },
  { value: SURVEY_ANSWERS, label: $gettext('Survey Answers') },
  { value: SURVEY_RESPONSES, label: $gettext('Survey Responses') },
  { value: USERS, label: $gettext('Users') },
  { value: USER_DONATIONS, label: $gettext('User Donations') },
  { value: USER_EVENTS, label: $gettext('User Events') },
  { value: RECURRING_DONATIONS, label: $gettext('Recurring Donations') }
]

const STAFF_ONLY_DATASETS = [
  { value: ORGANIZATION_DEFAULT, label: $gettext('Organization Configuration') },
]

export default {
  ANONYMOUS_DONATIONS,
  DISBURSEMENTS,
  EMPLOYEE_CODE_IMPORTS,
  EVENTS,
  EXPENSES,
  MESSAGES,
  EXTERNAL_DONATIONS,
  PAYROLL_REQUESTS,
  REQUESTS,
  SURVEY_ANSWERS,
  SURVEY_RESPONSES,
  USERS,
  USER_DONATIONS,
  USER_EVENTS,
  RECURRING_DONATIONS,
  EXPORTABLE_DATASETS,
  ADMIN_AUDIT_TRAIL,
  STAFF_ONLY_DATASETS,
  ORGANIZATION_DEFAULT,
}
